import * as React from 'react';
import { useState } from "react";
import {
    Box,
    Button,
    FormControl,
    CircularProgress,
    Paper,
    Grid,
    Checkbox as MUICheckbox,
    Divider,
    Modal,
    Link,
    Typography,
    TextField as MUITextField
} from '@mui/material';
import api from "../../services/api";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
import {
    TextField,
    Select,
    Checkbox,
    CNPJField,
    Autocomplete,
    TelField,
    CEPField,
    CPFField,
    SelectUF,
    SelectCidade,
    FileField,
    DialogoConfirmacaoSimples,
    JustificativasDropdown,
    PopupConfirmacao,
} from '../../components';
import { useStoreState, useStoreActions } from 'easy-peasy';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { constituicaoEmpresaFornecedor, estagioFornecedor } from '../../static';
import { DialogoVisualizador } from '../../components';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
// import { linkEditais } from './constants';
import DownloadIcon from '@mui/icons-material/Download';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const FornecedorCadastro = () => {
    let loading = useStoreState((state) => state.nav.loading);
    let startLoading = useStoreActions((actions) => actions.nav.startLoading);
    let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
    let user = useStoreState((state) => state.auth.user);
    const [tecnologias, setTecnologias] = React.useState([]);
    const [servicos, setServicos] = React.useState([]);
    const [regioes, setRegioes] = React.useState([]);
    const [estados, setEstados] = React.useState([]);
    const [selectedEstados, setSelectedEstados] = React.useState([]);
    const [isSP, setIsSP] = React.useState(false);
    const [categorias, setCategorias] = React.useState([]);
    const [fornecedor, setFornecedor] = React.useState([]);

    const [cities, setCities] = React.useState([]);
    const [states, setStates] = React.useState([]);
    const [fileVisualizador, setFileVisualizador] = React.useState();
    const [nomeDocumento, setNomeDocumento] = React.useState();
    const [nomeCampoDocumento, setNomeCampoDocumento] = React.useState();
    const [idFornecedor, setIdFornecedor] = React.useState();
    const [openDlgVis, setOpenDlgVis] = React.useState(false);
    const [openDlgAdd, setOpenDlgAdd] = React.useState(false);
    const [submeterAprovacao, setSubmeterAprovacao] = React.useState(false);

    const [openConfirmaExcluir, setOpenConfirmaExcluir] = React.useState(false);
    const [excluirId, setExcluirId] = React.useState(null);
    const [excluirNomeCampo, setExcluirNomeCampo] = React.useState(null);
    const [excluirTitulo, setExcluirTitulo] = React.useState("");
    const [editais, setEditais] = React.useState([]);

    const [rows, setRows] = useState([{ nome: "", email: "", estado: "" }]);
    const [openPopup, setOpenPopup] = useState(false);
    const [confirma, setConfirma] = useState(false);

    const [loadingCnpj, setLoadingCnpj] = React.useState(false);

    const defaultValues = {
        nome: '',
        responsavel: '',
        email: '',
        cnpj: '',
        habilitado: true,
        regioes: [],
        tecnologias: [],
        servicos: [],
        usuariosAdicionais: [{ nome: '', email: '', estado: '' }],
        estado: '',     
        cidade: '',
    };

    const schema = yup.object({
        nome: yup.string().label('Nome da empresa').required(),
        responsavel: yup.string().label('Nome do responsável legal').required(),
        email: yup.string().email().label('Email do responsável').required(),
        cnpj: yup.string().cnpj().label('CNPJ').required(),
        tecnologias: yup.array(yup.number().positive().integer())
            .min(1).nullable().label('Tecnologia').required(),
        servicos: yup.array(yup.number().positive().integer())
            .min(1).nullable().label('Serviços').required(),
        estados: yup.array(yup.number().positive().integer())
            .min(1).nullable().label('Em quais estados a empresa deseja atuar?').required(),
        regioes: yup.array(yup.number().positive().integer())
            .nullable().label('Região').required(),
        emailAux: yup.string().email().label("E-mail secundário").required(),
        telefone: yup.string().label("Telefone").required(),
        cep: yup.string().optional().label("CEP"),
        rua: yup.string().optional().label("Rua"),
        numero: yup.string().optional().label("Número"),
        bairro: yup.string().optional().label("Bairro"),
        cidade: yup.string().optional().label("Cidade"),
        uf: yup.string().optional().label("Estado"),
        atuaEsco: yup.boolean().nullable().label('A empresa atua como uma ESCO?'),
        constituicaoEmpresa: yup.number().nullable().label('Qual o porte da empresa?'),
        idDocumento: yup.number().positive().nullable().label('Selecionar').optional(),
        cpf: yup.string().label("CPF"),
        cargo: yup.string().label("Cargo"),
        usuariosAdicionais: yup.array().of(
            yup.object().shape({
              email: yup.string().email().required().label("Email"),
              nome: yup.string().required().label("Nome"),
              estado: yup.string().required().label("Estado"),
            })
          ) 
    }).required();
    
    
    const useFormRef = useForm({
      mode: 'onTouched',
      resolver: yupResolver(schema),
      defaultValues: defaultValues
    });
    
    const { 
      control, 
      register, 
      handleSubmit, 
        watch, 
        reset,
        resetField,
        getFieldState, 
        setValue, 
        getValues,
        formState: { isDirty, errors }
    } = useFormRef;
    
    const mapFornecedor = (fornecedor, currentValues = {}) => ({
        ...fornecedor,
        nome: fornecedor.nome ?? currentValues.nome ?? "",
        responsavel: fornecedor.responsavel ?? currentValues.responsavel ?? "",
        email: fornecedor.email ?? currentValues.email ?? "",
        cnpj: fornecedor.cnpj ?? currentValues.cnpj ?? "",
        cpf: fornecedor.cpf ?? currentValues.cpf ?? "",
        cargo: fornecedor.cargo ?? currentValues.cargo ?? "",
        telefone: fornecedor.telefone ?? currentValues.telefone ?? "",
        emailAux: fornecedor.emailAux ?? currentValues.emailAux ?? "",
        cep: fornecedor.cep ?? currentValues.cep ?? "",
        rua: fornecedor.rua ?? currentValues.rua ?? "",
        numero: fornecedor.numero ?? currentValues.numero ?? "",
        bairro: fornecedor.bairro ?? currentValues.bairro ?? "",
        cidade: fornecedor.cidade ?? currentValues.cidade ?? "",
        uf: fornecedor.uf ?? currentValues.uf ?? "",
        usuariosAdicionais: fornecedor.usuariosAdicionais?.map((u) => ({
            nome: u.nome || '',
            email: u.email || '',
            estado: u.uf || '',
        })) ?? currentValues.usuariosAdicionais ?? [{ nome: "", email: "", estado: "" }],
        regioes: fornecedor.regiao?.map((r) => r.id) ?? currentValues.regioes ?? [],
        tecnologias: fornecedor.tecnologia?.map((t) => t.id) ?? currentValues.tecnologias ?? [],
        servicos: fornecedor.servico?.map((s) => s.id) ?? currentValues.servicos ?? [],
        estados: fornecedor.estado?.map((e) => e.id) ?? currentValues.estados ?? [],
    });

    const watchUF = watch("uf");
    const watchCPF = watch("cpf");
    const watchCargo = watch("cargo");
    const watchUsuariosAdicionais = watch("usuariosAdicionais");
    const constituicaoEmpresa = watch("constituicaoEmpresa");
    const idDocumento = watch("idDocumento");

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        pt: 2,
        px: 4,
        pb: 3,
    };

    //const disabled = fornecedor.estagioFornecedor === "analise" && fornecedor.analisadorId;

    React.useEffect(() => {
        async function fetchStates() {
            try {
                const response = await fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados');
                const data = await response.json();
            
                const sortedStates = data.sort((a, b) => {
                    return a.nome.localeCompare(b.nome); 
                });

                setStates(sortedStates);

            } catch (error) {
                console.error('Error fetching states:', error);
            }
        }

        fetchStates();
    }, []);

    React.useEffect(() => {
        let mount = { isMounted: true };
        loadCategorias(mount);
        loadTecnologias(mount);
        loadServicos(mount);
        loadRegioes(mount);
        loadEstados(mount);
        loadfornecedor(mount);

        return () => { mount.isMounted = false; };
    }, []);



    React.useEffect(() => {
        const isSubmeterAprovacao = () => {
            if (fornecedor.actId
                && fornecedor.catId
                && fornecedor.declaracaoFabricanteId
                && fornecedor.certidaoCreaId
                && fornecedor.pedidoPublicoAnexo1Id
                && fornecedor.outrasInformacoesAnexo9Id
                && (fornecedor.documentosMeiId
                    || fornecedor.atoSociedadeSimplesId
                    || fornecedor.atoSociedadeAcoesId)
                && fornecedor.negativaFalenciaId
                && fornecedor.certidaoVirgenteId
                && fornecedor.balancoPatrimonialId
                && fornecedor.provaInscCnpjId
                && fornecedor.cadastroContribuinteMunicipalId
                && fornecedor.cadastroContribuinteEstadualId
                && fornecedor.regularidadeFazendaNacionalId
                && fornecedor.regularidadeFazendaEstadualId
                && fornecedor.regularidadeFazendaMunicipalId
                && fornecedor.regularidadeFgtsId
                && fornecedor.regularidadeJusticaTrabalhoId
                && fornecedor.termoCompromissoAssinaturaEletronicaId
            ) {
                setSubmeterAprovacao(true);
                // console.log("submenter aprovação");
            }
            // else { console.log("não submeter"); }
        }
        ////   testar se todos os dados foram preenchidos e liberar para submeterAprovacao
        isSubmeterAprovacao();
    }, [fornecedor])

    const loadCategorias = async (mount) => {
        startLoading();
        try {
            let data = (await api.http.get('/categorias')).data;
            if (mount.isMounted) {
                setCategorias(data);
            }
            stopLoading();
        } catch (error) {
            stopLoading({ message: error.toString(), severity: 'error' });
        }
    };

    const loadTecnologias = async (mount) => {
        startLoading();
        try {
            let data = (await api.http.get('/tecnologias')).data;
            if (mount.isMounted) {
                setTecnologias(data);
            }
            stopLoading();
        } catch (error) {
            stopLoading({ message: error.toString(), severity: 'error' });
        }
    };

    const loadServicos = async (mount) => {
        startLoading();
        try {
            let data = (await api.http.get('/servicos')).data;
            if (mount.isMounted) {
                setServicos(data);
            }
            stopLoading();
        } catch (error) {
            stopLoading({ message: error.toString(), severity: 'error' });
        }
    };


    const loadRegioes = async (mount) => {
        startLoading();
        try {
            let data = (await api.http.get('/regioes')).data;
            if (mount.isMounted) {
                setRegioes(data);
            }
            stopLoading();
        } catch (error) {
            stopLoading({ message: error.toString(), severity: 'error' });
        }
    };
    const loadEstados = async (mount) => {
        startLoading();
        try {
            let data = (await api.http.get('/estados')).data;
            if (mount.isMounted) {
                setEstados(data);
            }
            stopLoading();
        } catch (error) {
            stopLoading({ message: error.toString(), severity: 'error' });
        }
    };

    const loadfornecedor = async (mount) => {
        startLoading();
        try {
            const data = (await api.http.get(`/fornecedores/interesses?id=${user.id}`)).data;

            if (mount.isMounted && data[0]) {
            const fornecedor = data[0];
            setFornecedor(fornecedor);

            reset(
                {
                ...mapFornecedor(fornecedor, getValues()),
                },
                { keepDirtyValues: true }
            );

            setRows(fornecedor.usuariosAdicionais || []);

            if (fornecedor.estado) {
                setSelectedEstados(fornecedor.estado);
                setIsSP(fornecedor.estado.some((option) => option?.label === 'São Paulo'));
            }
            }

            stopLoading();
        } catch (error) {
            stopLoading({ message: error.toString(), severity: 'error' });
        }
    };
      

    React.useEffect(() => {
        async function fetchCities() {
            if (watchUF) {
                try {
                    const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${watchUF}/municipios`);
                    const data = await response.json();
                    setCities(data);

                } catch (error) {
                    console.error('Error fetching cities:', error);
                }
            } else {
                setCities([]);
            }
        }

        fetchCities();
    }, [watchUF]);

    const normalizeUsuariosAdicionais = (list) =>
      (list || [])
        .map((u) => ({
          nome: (u?.nome || "").trim(),
          email: (u?.email || "").trim(),
          estado:
            typeof u?.estado === "string"
              ? u.estado.trim()
              : (u?.estado?.sigla || u?.estado?.uf || u?.estado?.nome || "").trim(),
        }))
        .filter((u) => u.nome && u.email && u.estado);

    const salvarResponsaveis = async (fornecedorId) => {
      const usuarios = normalizeUsuariosAdicionais(getValues("usuariosAdicionais"));

      await api.http.put(`/fornecedores/orcamentos/alterarestagio/${fornecedorId}`, {
        estagioFornecedor: fornecedor.estagioFornecedor,
        cpf: getValues("cpf"),
        cargo: getValues("cargo"),
        usuariosAdicionais: usuarios,
      });
    };

    const onSave = async (data) => {
        startLoading();
        try {
            if (data.id) {
                await api.http.put('/fornecedores/' + data.id, data);
            } else {
                await api.http.post('/fornecedores', data);
            }
            stopLoading({ severity: 'success' });
        } catch (error) {
            stopLoading({ message: error.toString(), severity: 'error' });
            throw error;
        }
    };

    const onSubmit = async (data) => {
        try {
          await onSave(data);
          setOpenPopup(true);
        } catch (error) {
          console.error('Erro ao salvar:', error);
        }
      };
      
    const onError = (errors) => {
        console.log('Erros de validação:', errors);
        
        if (errors) {
            const fieldName = Object.keys(errors)[0];
            const fieldElement = document.querySelector(`[name="${fieldName}"]`);
        
            if (fieldElement) {
                fieldElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                fieldElement.focus();
            }
        }
    };

    React.useEffect(() => {
        if (!isDirty && fornecedor) {
            reset(
            {
                ...mapFornecedor(fornecedor, getValues()),
            },
            { keepDirtyValues: true }
            );
        }
    }, [fornecedor, reset]);
      


    const onCloseDlgVis = () => {
        setOpenDlgVis(false);
    };

    const onCloseAdd = () => {
        setNomeCampoDocumento(null);
        setIdFornecedor(null);
        setNomeDocumento(null);
        setOpenDlgAdd(false);
    };
    
    const onConfirmarAdd = async () => {
      startLoading();
      try {
        const response = await api.http.put(
          '/fornecedores/add/file/' + idFornecedor,
          {
            id: idFornecedor,
            nomeCampo: nomeCampoDocumento,
            idDocumento: idDocumento
          }
        );

        const fileData = response.data?.[0];

        setFornecedor(prev => ({
          ...prev,
          ...fileData
        }));

        stopLoading({ severity: 'success' });
        setOpenDlgAdd(false);

      } catch (error) {
        stopLoading({ message: error.toString(), severity: 'error' });
        setOpenDlgAdd(false);
      }
    };

    const onOpenDlgVis = (param1, param2, param3) => {
        setFileVisualizador(param1);
        setOpenDlgVis(true);
    };

    const onOpenDlgAdd = (param1, param2, param3) => {
        setValue('idDocumento', null);
        setNomeCampoDocumento(param1);
        setIdFornecedor(param2);
        setNomeDocumento(param3);
        setOpenDlgAdd(true);

    };

    const onDelete = async (param1, param2, param3) => {

        setExcluirId(param2);
        setExcluirNomeCampo(param1);
        setExcluirTitulo(param3);
        setOpenConfirmaExcluir(true);

    };

    const onConfirmaExcluir = async () => {
        startLoading();
        try {

            let data = (await api.http.put('/fornecedores/delete/file/' + excluirId, {
                id: excluirId,
                nomeCampo: excluirNomeCampo,
                idDocumento: 0
            })).data;

            setFornecedor(data[0]);

            stopLoading({ severity: 'success' });
            setOpenConfirmaExcluir(false);

        } catch (error) {
            stopLoading({ message: error.toString(), severity: 'error' });
            setOpenConfirmaExcluir(false);
            throw error;
        }
    };

    const onNaoConfirmaExcluir = async (data) => {
        setOpenConfirmaExcluir(false);
    };


    React.useEffect(() => {
      async function fetchEditais() {
        let datalink = (await api.http.get(`/fornecedores/editais?page=1&pageSize=5&uf=${fornecedor.uf}`)).data;
        setEditais(datalink);
      }

      fetchEditais();
    }, [fornecedor.uf]);

    const handleSolicitaAnalise = async () => {
        startLoading();
        try {
            const usuarios = normalizeUsuariosAdicionais(watchUsuariosAdicionais);
            const data = await api.http.put('/fornecedores/orcamentos/alterarestagio/' + fornecedor.id, {
                estagioFornecedor: "analise",
                cpf: watchCPF,
                cargo: watchCargo,
                usuariosAdicionais: usuarios,
            }).data;

            let datafor = (await api.http.get(`/fornecedores/interesses?id=${user.id}`)).data;

            setFornecedor(datafor[0]);

            //window.location.reload();

            stopLoading({ severity: 'success' });

        } catch (error) {
            stopLoading({ message: error.toString(), severity: 'error' });
            throw error;
        }
    }

    const getDescricaoEstagio = (cod) => {
        const estagio = estagioFornecedor.find((e) => e.cod === cod);
        return estagio ? estagio.descricao : "Desconhecido";
    };

    const handleDownload = async () => {
      const response = await api.http.get("/download/edital-anexo", {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "02.Anexos_Edital-PotencializEE-2026.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
    };

    const loadCEP = async (cep) => {
        const cleanCEP = cep.replace(/\D/g, '');
        if (cleanCEP.length === 8) { // Valida se o CEP tem 8 dígitos
            try {
                const response = await fetch(`https://viacep.com.br/ws/${cleanCEP}/json/`);
                const data = await response.json();

                if (!data.erro) {
                    // Atualiza os valores no formulário
                    setValue('rua', data.logradouro);
                    setValue('bairro', data.bairro);
                    setValue('uf', data.uf);
                    setValue('cidade', data.localidade);
                } else {
                    alert('CEP não encontrado');
                }
            } catch (error) {
                console.error('Erro ao buscar o CEP:', error);
                alert('Erro ao buscar o CEP');
            }
        }
    };

    const loadCNPJ = async () => {
      const cnpj = getValues('cnpj');
      const cleanCNPJ = cnpj?.replace(/\D/g, '');

      if (!cleanCNPJ || cleanCNPJ.length !== 14) return;

      try {
        setLoadingCnpj(true);

        const response = await fetch(
          `https://brasilapi.com.br/api/cnpj/v1/${cleanCNPJ}`
        );

        if (!response.ok) {
          throw new Error('CNPJ não encontrado');
        }

        const data = await response.json();

        const safeSet = (field, value) => {
          if (!getValues(field) && value) {
            setValue(field, value, { shouldDirty: true });
          }
        };

        safeSet('nome', data.razao_social);
        safeSet('email', data.email);
        safeSet('telefone', data.ddd_telefone_1);
        if(data.cep){
          safeSet('cep', data.cep);
          loadCEP(data.cep);
        }
        if(data.numero){
          safeSet('numero', data.numero);
        }

      } catch (err) {
        console.error(err);
      } finally {
        setLoadingCnpj(false);
      }
    };

    const addRow = () => {
      const current = getValues("usuariosAdicionais") || [];
      const updated = [...current, { nome: "", email: "", estado: "" }];
      setValue("usuariosAdicionais", updated, { shouldDirty: true });
    };

    const deleteRow = (indexToRemove) => {
      const current = getValues("usuariosAdicionais") || [];
      const updated = current.filter((_, i) => i !== indexToRemove);
      setValue("usuariosAdicionais", updated, { shouldDirty: true });
    };

    const renderDocumentoBox = (
        titulo,
        arquivoKey,
        aprovadoKey,
        colunaReferencia,
        idCampo,
        labelCampo
      ) => {
        const arquivo = fornecedor[arquivoKey];
        const aprovado = fornecedor[aprovadoKey];
        const estagio = fornecedor.estagioFornecedor;
      
        const getStatusColor = (status) =>
          status === 2 ? 'red' : status === 1 ? 'green' : 'darkgray';
      
        return (
          <Box
            sx={{
              backgroundColor: 'white',
              borderBottom: '1px solid #FAFBFB',
              marginTop: 2,
              padding: 2,
              position: 'relative',
            }}
            key={idCampo}
          >
            <Grid item xs={6}>
              <h4>{titulo}</h4>
            </Grid>
      
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={3}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {arquivo && (
                    <>
                      <Button
                        color="secondary"
                        variant="outlined"
                        startIcon={<ArticleOutlinedIcon />}
                        onClick={() => onOpenDlgVis(arquivo, fornecedor.id, 'Valor3')}
                      >
                        Visualizar
                      </Button>
      
                      {(estagio === 'inativo' || estagio === 'pendencia') && (
                        <Button
                          color="warning"
                          variant="outlined"
                          startIcon={<DeleteForeverOutlinedIcon />}
                          onClick={() => onDelete(idCampo, fornecedor.id, labelCampo)}
                        >
                          Remover
                        </Button>
                      )}
                    </>
                  )}
      
                  {(!arquivo || aprovado === 2) && (
                    <Button
                      color="success"
                      variant="outlined"
                      startIcon={<BackupOutlinedIcon />}
                      onClick={() => onOpenDlgAdd(idCampo, fornecedor.id, labelCampo)}
                    >
                      Incluir
                    </Button>
                  )}
                </Box>
              </Grid>
      
              <Grid item xs={2}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 'bold',
                    textAlign: 'center',
                    color: getStatusColor(aprovado),
                    mt: '4px',
                  }}
                >
                  Aprovado: {aprovado === 1 ? 'Sim' : aprovado === 2 ? 'Não' : '-'}
                </Typography>
              </Grid>
      
              <Grid item xs={7}>
                <Box sx={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
                  {aprovado === 2 && (
                    <Box sx={{ width: '100%', maxWidth: '500px' }}>
                      <JustificativasDropdown
                        fornecedor={fornecedor}
                        colunaReferencia={colunaReferencia}
                      />
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        );
    };

    return (
        <Box sx={{ p: 3 }}>
            <DialogoConfirmacaoSimples
                title="Atenção"
                open={openConfirmaExcluir}
                onSim={onConfirmaExcluir}
                onNao={onNaoConfirmaExcluir}
            >
                <h4>{excluirTitulo}</h4>
                Tem certeza que deseja excluir o arquivo?
            </DialogoConfirmacaoSimples>
            <Modal
                open={openDlgAdd}
                onClose={onCloseAdd}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={{ ...style, width: 400 }}>
                    <h2 id="parent-modal-title">Adicionar arquivo</h2>
                    <h3>{nomeDocumento}</h3>
                    <p id="parent-modal-description">
                        Selecione o documento que deseja incluir:
                    </p>

                    <FormControl sx={{ mb: 2 }} fullWidth>
                        <FileField
                            field="idDocumento"
                            fileData={fornecedor?.idDocumento}
                            useFormRef={useFormRef}
                            schema={schema}
                        />
                    </FormControl>

                    {/* <ChildModal /> */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <Button
                            color="warning"
                            onClick={() => onCloseAdd()}
                        >
                            Fechar
                        </Button>
                        <Button
                            color="success"
                            disabled={!idDocumento}
                            onClick={() => onConfirmarAdd()}
                        >
                            Confirma
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <DialogoVisualizador file={fileVisualizador} open={openDlgVis} onClose={onCloseDlgVis} />
            <Paper elevation={3} sx={{ p: 3 }}>
                <h2>Dados cadastrais</h2>
                {editais.data && editais.data.length > 0 && (
                    editais.data.map((item) => (
                        <Button
                            key={item.id}
                            href={item.linkUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="outlined"
                            color="info"
                            startIcon={<DownloadIcon />}
                            style={{ margin: '8px 5px', textTransform: 'none' }}
                        >
                            {item.titulo}
                        </Button>

                    ))
                )}


                <FormControl sx={{ my: 2 }} fullWidth>
                  <CNPJField
                    margin="dense"
                    fullWidth
                    field="cnpj"
                    useFormRef={useFormRef}
                    schema={schema}
                    disabled={true}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      endAdornment: (
                        <Button
                          onClick={loadCNPJ}
                          disabled={loadingCnpj}
                          size="small"
                          variant="outlined"
                          sx={{ ml: 1, whiteSpace: 'nowrap' }}
                        >
                          {loadingCnpj ? (
                            <CircularProgress size={18} />
                          ) : (
                            'Buscar'
                          )}
                        </Button>
                      )
                    }}
                  />
                </FormControl>
                <FormControl sx={{ my: 2 }} fullWidth>
                    <TextField
                        margin="dense"
                        fullWidth
                        field="nome"
                        useFormRef={useFormRef}
                        // disabled={disabled}
                        schema={schema}
                    />
                </FormControl>
                <FormControl sx={{ my: 2 }} fullWidth>
                    <TextField
                        margin="dense"
                        fullWidth
                        field="responsavel"
                        useFormRef={useFormRef}
                        schema={schema}
                    // disabled={disabled}
                    />
                </FormControl>
                <FormControl sx={{ my: 2 }} fullWidth>
                    <TextField
                        margin="dense"
                        fullWidth
                        field="email"
                        type="email"
                        useFormRef={useFormRef}
                        schema={schema}
                    // disabled={disabled}
                    />
                </FormControl>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <FormControl sx={{ my: 1 }} fullWidth>
                            <TelField
                                margin="dense"
                                field="telefone"
                                // disabled={disabled}
                                useFormRef={useFormRef}
                                schema={schema}
                                InputLabelProps={{ shrink: true }}

                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl sx={{ my: 1 }} fullWidth>
                            <TextField
                                margin="dense"
                                fullWidth
                                field="emailAux"
                                type="email"
                                useFormRef={useFormRef}
                                // disabled={disabled}
                                schema={schema} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl sx={{ my: 1 }} fullWidth>
                            <CPFField
                                margin="dense"
                                fullWidth
                                field="cpf"
                                useFormRef={useFormRef}
                                schema={schema}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl sx={{ my: 1 }} fullWidth>
                            <TextField
                                margin="dense"
                                fullWidth
                                field="cargo"
                                useFormRef={useFormRef}
                                schema={schema} 
                                //label="Cargo"
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <FormControl sx={{ my: 2 }} fullWidth>
                            <CEPField
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                field="cep"
                                // disabled={disabled}
                                useFormRef={useFormRef}
                                schema={schema}
                                onBlur={(e) => loadCEP(e.target.value)}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={8}>
                        <FormControl sx={{ my: 2 }} fullWidth>
                            <TextField
                                field="rua"
                                // disabled={disabled}
                                useFormRef={useFormRef}
                                schema={schema}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={2}>
                        <FormControl sx={{ my: 2 }} fullWidth>
                            <TextField
                                field="numero"
                                // disabled={disabled}
                                useFormRef={useFormRef}
                                schema={schema}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl sx={{ my: 2 }} fullWidth>
                            <TextField
                                field="bairro"
                                // disabled={disabled}
                                useFormRef={useFormRef}
                                schema={schema}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl sx={{ my: 2 }} fullWidth>
                            <SelectUF
                                field="uf"
                                useFormRef={useFormRef}
                                schema={schema}
                                //disabled={disabled}
                                options={states}
                                getOptionLabel={(option) => option.nome}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl sx={{ my: 2 }} fullWidth>
                            <SelectCidade
                                field="cidade"
                                useFormRef={useFormRef}
                                schema={schema}
                                //disabled={disabled}
                                options={cities}
                                getOptionLabel={(option) => option.nome}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl>
                            <Checkbox field="atuaEsco"
                                useFormRef={useFormRef}
                                //disabled={disabled} 
                                schema={schema} />
                        </FormControl>
                    </Grid>
                </Grid>

                <Divider>
                    <h3>Atuação</h3>
                </Divider>
                <FormControl sx={{ my: 2 }} fullWidth>
                    <Autocomplete
                        multiple
                        disableCloseOnSelect
                        field="tecnologias"
                        useFormRef={useFormRef}
                        schema={schema}
                        //disabled={disabled}
                        options={tecnologias}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                <MUICheckbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {props.key}
                            </li>
                        )}
                    />
                </FormControl>

                <FormControl sx={{ my: 2 }} fullWidth>
                    <Autocomplete
                        multiple
                        disableCloseOnSelect
                        field="servicos"
                        useFormRef={useFormRef}
                        schema={schema}
                        options={servicos}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                <MUICheckbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {props.key}
                            </li>
                        )}
                    />
                </FormControl>

                <FormControl sx={{ my: 2 }} fullWidth>
                    <Autocomplete
                        multiple
                        disableCloseOnSelect
                        field="estados"
                        useFormRef={useFormRef}
                        schema={schema}
                        onChange={(selectedOptions) => {  
                            setSelectedEstados(selectedOptions);
                            setIsSP(selectedOptions.some(option => option?.label === 'São Paulo'));
                        }}
                        options={estados}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                <MUICheckbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.label} 
                            </li>
                        )}
                    />
                </FormControl>

                {isSP && (
                    <FormControl sx={{ my: 2 }} fullWidth>
                        <Autocomplete
                            multiple
                            disableCloseOnSelect
                            field="regioes"
                            useFormRef={useFormRef}
                            schema={schema}
                            options={regioes}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <MUICheckbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {props.key}
                                </li>
                            )}
                        />
                    </FormControl>
                )}

                <FormControl x={{ mb: 2 }} fullWidth>
                    <Select
                        field="constituicaoEmpresa"
                        useFormRef={useFormRef} schema={schema}
                        options={constituicaoEmpresaFornecedor}
                    //disabled={disabled}
                    />
                </FormControl>

                <Divider sx={{ my: 2}}>
                    <h3 >Responsáveis pelas propostas</h3>
                </Divider>

                <Grid container spacing={2}>
                    {watchUsuariosAdicionais.map((row, index) => (
                    <Grid container spacing={2} sx={{ mt: 1 }} key={index} alignItems="center">
                        <Grid item xs={4}>
                            <FormControl sx={{ my: 1 }} fullWidth>
                                <TextField
                                    margin="dense"
                                    fullWidth
                                    field={`usuariosAdicionais[${index}].nome`}
                                    useFormRef={useFormRef}
                                    schema={schema} 
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl sx={{ my: 1 }} fullWidth>
                                <TextField
                                    margin="dense"
                                    fullWidth
                                    field={`usuariosAdicionais[${index}].email`}
                                    useFormRef={useFormRef}
                                    schema={schema} 
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl sx={{ my: 1 }} fullWidth>
                                <SelectUF
                                    label="Estado"
                                    field={`usuariosAdicionais[${index}].estado`}
                                    useFormRef={useFormRef}
                                    schema={schema}
                                    options={states}
                                    getOptionLabel={(option) => option.nome}
                                    fullWidth
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    ))}

                    <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2} sx={{ mt: 2 }}>
                    <Button variant="outlined" color="primary" onClick={addRow}>
                        Adicionar Linha
                    </Button>
                    <Button variant="outlined" color="error" onClick={() => deleteRow(watchUsuariosAdicionais.length-1)}>
                        Remover Linha
                    </Button>
                    </Grid>
                </Grid>

                <Divider>
                    <h3>Documentação Técnica</h3>
                    <h3>Qualificação Técnica</h3>
                </Divider>

                <div>
                    <h4 align="justify">
                        Todos os documentos solicitados aqui estão explicados detalhadamente no edital disponível <a href="https://www.programa-potencializee.com.br/wp-content/uploads/2026/01/06012026-edital-potencializee-v8-termo-de-adesao-e-logreversa.pdf" target="_blank" rel="noopener noreferrer">aqui</a> para consulta. 
                        Caso algum desses documentos não se aplique à sua empresa, é necessário que seja anexada uma justificativa 
                        em papel timbrado contendo a assinatura do responsável pelo cadastro.
                    </h4>
                </div>
                <Divider sx={{ mb: 4 }} />

                    {renderDocumentoBox(
                    '1. ACT',
                    'arquivoAct',
                    'actAprovado',
                    'act_aprovado',
                    'actId',
                    'Act'
                    )}

                    {renderDocumentoBox(
                    '2. CAT',
                    'arquivoCat',
                    'catAprovado',
                    'cat_aprovado',
                    'catId',
                    'CAT'
                    )}

                    {renderDocumentoBox(
                    '3. Declaração do Fabricante',
                    'arquivodeclaracaoFabricanteId',
                    'declaracaoFabricanteAprovado',
                    'declaracao_fabricante_aprovado',
                    'declaracaoFabricanteId',
                    'Declaração do fabricante'
                    )}

                    {renderDocumentoBox(
                    '4. Certidão de Registro - CREA Pessoa Jurídica',
                    'arquivocertidaoCreaId',
                    'certidaoCreaAprovado',
                    'certidao_crea_aprovado',
                    'certidaoCreaId',
                    'Certidão de Registro - CREA Pessoa Jurídica'
                    )}

                    <Divider>
                        <h3>Documentação habilitação</h3>
                        <h3>Qualificação Técnica</h3>
                    </Divider>

                    {renderDocumentoBox(
                    '5. Pedido Público (Anexo I)',
                    'arquivopedidoPublicoAnexo1Id',
                    'pedidoPublicoAnexo1Aprovado',
                    'pedido_publico_anexo1_aprovado',
                    'pedidoPublicoAnexo1Id',
                    'Pedido Público (Anexo I)'
                    )}

                    {renderDocumentoBox(
                    '6. Declaração de Outras Informações (Anexo IX)',
                    'arquivooutrasInformacoesAnexo9Id',
                    'outrasInformacoesAnexo9Aprovado',
                    'outras_informacoes_anexo9_aprovado',
                    'outrasInformacoesAnexo9Id',
                    'Declaração de outras informações (Anexo IX)'
                    )}

                    {constituicaoEmpresa === 1 &&
                    renderDocumentoBox(
                        '7. Documentos - MEI',
                        'arquivodocumentosMeiId',
                        'documentosMeiAprovado',
                        'documentos_mei_aprovado',
                        'documentosMeiId',
                        'Documentos - Mei'
                    )}

                    {constituicaoEmpresa === 2 &&
                    renderDocumentoBox(
                        '7. Ato Constitutivo - Sociedades Simples',
                        'arquivoatoSociedadeSimplesId',
                        'atoSociedadeSimplesAprovado',
                        'ato_sociedade_simples_aprovado',
                        'atoSociedadeSimplesId',
                        'Ato Constitutivo - Sociedades Simples'
                    )}

                    {constituicaoEmpresa === 3 &&
                    renderDocumentoBox(
                        '7. Ato Constitutivo - Sociedades por Ações',
                        'arquivoatoSociedadeAcoesId',
                        'atoSociedadeAcoesAprovado',
                        'ato_sociedade_acoes_aprovado',
                        'atoSociedadeAcoesId',
                        'Ato Constitutivo - Sociedades por Ações'
                    )}

                    {renderDocumentoBox(
                    '8. Certidão Negativa Falência ou Certidão Judicial',
                    'arquivonegativaFalenciaId',
                    'negativaFalenciaAprovado',
                    'negativa_falencia_aprovado',
                    'negativaFalenciaId',
                    'Certidão Negativa Falência ou Certidão Judicial'
                    )}

                    {renderDocumentoBox(
                    '9. Certidão vigente emitida pela instância Judicial',
                    'arquivocertidaoVirgenteId',
                    'certidaoVirgenteAprovado',
                    'certidao_virgente_aprovado',
                    'certidaoVirgenteId',
                    'Certidão vigente emitida pela instância Judicial'
                    )}

                    {renderDocumentoBox(
                    '10. Balanço Patrimonial e Demonst. Contábeis',
                    'arquivobalancoPatrimonialId',
                    'balancoPatrimonialAprovado',
                    'balanco_patrimonial_aprovado',
                    'balancoPatrimonialId',
                    'Balanço Patrimonial e Demonst. contábeis'
                    )}

                    <Divider>
                        <h3>Regularidade Fiscal</h3>
                    </Divider>

                    {renderDocumentoBox(
                    '11. Prova de Inscrição - CNPJ',
                    'arquivoprovaInscCnpjId',
                    'provaInscCnpjAprovado',
                    'prova_insc_cnpj_aprovado',
                    'provaInscCnpjId',
                    'Prova de Inscrição - CNPJ'
                    )}

                    {renderDocumentoBox(
                    '12. Cadastro de Contribuinte Municipal',
                    'arquivocadastroContribuinteMunicipalId',
                    'cadastroContribuinteMunicipalAprovado',
                    'cadastro_contribuinte_municipal_aprovado',
                    'cadastroContribuinteMunicipalId',
                    'Cadastro de Contribuinte Municipal'
                    )}

                    {renderDocumentoBox(
                    '13. Cadastro de Contribuinte Estadual',
                    'arquivocadastroContribuinteEstadualId',
                    'cadastroContribuinteEstadualAprovado',
                    'cadastro_contribuinte_estadual_aprovado',
                    'cadastroContribuinteEstadualId',
                    'Cadastro de Contribuinte Estadual'
                    )}

                    {renderDocumentoBox(
                    '14. Prova de Regularidade - Fazenda Nacional',
                    'arquivoregularidadeFazendaNacionalId',
                    'regularidadeFazendaNacionalAprovado',
                    'regularidade_fazenda_nacional_aprovado',
                    'regularidadeFazendaNacionalId',
                    'Prova de Regularidade - Fazenda Nacional'
                    )}

                    {renderDocumentoBox(
                    '15. Prova de Regularidade - Fazenda Estadual',
                    'arquivoregularidadeFazendaEstadualId',
                    'regularidadeFazendaEstadualAprovado',
                    'regularidade_fazenda_estadual_aprovado',
                    'regularidadeFazendaEstadualId',
                    'Prova de Regularidade - Fazenda Estadual'
                    )}

                    {renderDocumentoBox(
                    '16. Prova de Regularidade - Fazenda Municipal',
                    'arquivoregularidadeFazendaMunicipalId',
                    'regularidadeFazendaMunicipalAprovado',
                    'regularidade_fazenda_municipal_aprovado',
                    'regularidadeFazendaMunicipalId',
                    'Prova de Regularidade - Fazenda Municipal'
                    )}

                    {renderDocumentoBox(
                    '17. Prova de Regularidade - FGTS',
                    'arquivoregularidadeFgtsId',
                    'regularidadeFgtsAprovado',
                    'regularidade_fgts_aprovado',
                    'regularidadeFgtsId',
                    'Prova de Regularidade - FGTS'
                    )}

                    {renderDocumentoBox(
                    '18. Prova de Regularidade – Justiça do Trabalho',
                    'arquivoregularidadeJusticaTrabalhoId',
                    'regularidadeJusticaTrabalhoAprovado',
                    'regularidade_justica_trabalho_aprovado',
                    'regularidadeJusticaTrabalhoId',
                    'Prova de Regularidade – Justiça do Trabalho'
                    )}

                    {renderDocumentoBox(
                    '19. Termo de Compromisso – Assinatura do responsável legal',
                    'arquivotermoCompromissoAssinaturaEletronicaId',
                    'termoCompromissoAssinaturaEletronicaAprovado',
                    'termo_compromisso_assinatura_eletronica_aprovado',
                    'termoCompromissoAssinaturaEletronicaId',
                    'Termo de Compromisso – Assinatura do responsável legal'
                    )}

                    <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 2, ml: 2 }}>
                      <Button
                        variant="contained"
                        startIcon={<DownloadIcon />}
                        onClick={handleDownload}
                      >
                        Baixar Termo de Compromisso
                      </Button>
                    </Box>
                    

                {loading > 0 && (
                    <CircularProgress
                        size={30}
                        sx={{
                            position: 'absolute',
                            left: 25,
                            bottom: 12
                        }}
                    />
                )}
                <Grid container justifyContent="flex-end">
                    
                    <Grid container justifyContent="flex-end" gap={2}>
                      <Button variant="outlined" color='inherit' onClick={() => {
                          reset(defaultValues);
                          setConfirma(false);
                      }}>
                          Cancelar
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={handleSubmit(async (data) => {
                          await onSave(data);
                          await salvarResponsaveis(data.id || fornecedor.id);
                        }, onError)}
                      >
                        Salvar
                      </Button>
                      {((fornecedor.estagioFornecedor === "inativo"
                                              || fornecedor.estagioFornecedor === "pendencia")

                                          ) && (
                        <Button
                          variant="contained"
                          color="success"
                          disabled={!submeterAprovacao}
                          onClick={async () => {
                            await handleSubmit(onSave, onError)();
                            await handleSolicitaAnalise();
                          }}
                        >
                          Solicitar análise
                        </Button>
                      )}
                    </Grid>
                    <PopupConfirmacao
                        open={openPopup}
                        onClose={() => setOpenPopup(false)}
                        onConfirm={() => {
                            handleSolicitaAnalise();
                            setConfirma(true);
                        }}
                    />
                </Grid>
            </Paper>  
        </Box>
    );
};

export default FornecedorCadastro;
